import "./Loader.css";
const Loader = () => (
  <div className="backdrop" aria-busy="true" aria-live="polite">
    <div className="wrap">
      <div className="ball"></div>
      <div className="ball"></div>
      <div className="ball"></div>
    </div>
  </div>
);
export default Loader;
